<template>
  <div class="wrapper-base-notification-approve">
    <BaseNotificationTitle
      :code="code"
      :platform="platform"
      :dateTime="dateTime"
      :queueNumber="queueNumber"
      :tableNumber="tableNumber"
      :orderDetail="orderDetail"
      :responseStatus="responseStatus"
    />
    <div class="action">
      <div class="buttons">
        <div v-if="responseStatus && !['', 'unknown'].includes(queueNumber)">
          <button
            class="btn btn-light btn-sm"
            @click="handleClickViewOrderNo">
            {{ $t('apps.pos.message.queuenumber', { number: queueNumber }) }}
          </button>
        </div>
        <div v-if="!responseStatus">
          <button
            class="btn btn-danger btn-sm"
            @click="handleClickReject">
            {{ $t('button.reject') }}
          </button>
          <button
            class="btn btn-web btn-sm"
            @click="handleClickApprove">
            {{ $t('button.approve') }}
          </button>
        </div>
      </div>
      <div
        :style="[{ 'opacity': !isRead ? 1 : 0 }]"
        class="icon"
      >
        <i class="fas fa-circle"/>
      </div>
    </div>
  </div>
</template>
<script>
import { FIREBASE_NOTIFY_RESPONSE_STATUS } from '../../helpers/enum'
import BaseNotificationTitle from './BaseNotificationTitle.vue'

export default {
  props: {
    code: String,
    platform: String,
    dateTime: Number,
    queueNumber: String,
    tableNumber: String,
    orderDetail: Array,
    isRead: Boolean,
    responseStatus: String,
  },

  data() {
    return {
      FIREBASE_NOTIFY_RESPONSE_STATUS, FIREBASE_NOTIFY_RESPONSE_STATUS,
    }
  },

  components: {
    BaseNotificationTitle,
  },

  methods: {
    handleClickReject() {
      this.$emit('onClickReject')
    },
    handleClickApprove() {
      this.$emit('onClickApprove')
    },
    handleClickViewOrderNo() {
      this.$emit('onClickViewOrderNo')
    },
  },
}
</script>
<style scoped>
.wrapper-base-notification-approve {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 10px;
}
.action {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  gap: 15px;
}

.action .icon {
  width: 12px;
  color: #007FFF;
  font-size: 12px;
}
</style>



// WEBPACK FOOTER //
// src/components/base/BaseNotificationItemApprove.vue